
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-a-cka",
      function () {
        return require("private-next-pages/become-a-cka/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-a-cka"])
      });
    }
  